import gsap from 'gsap'
import { Flip } from 'gsap/Flip'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger, Flip)

export const initGallery = () => {
	const module = document.querySelector('.gallery')

	if (!module || window.innerWidth < 650) return

	const images = module.querySelectorAll('.gallery__item')
	const targets = module.querySelectorAll('.gallery__target-item')

	images.forEach((image, index) => {

		Flip.fit(images[index], targets[index], {
			duration: 10,
			ease: 'power1.inOut',
			scrollTrigger: {
				trigger: module,
				start: 'top 70%',
				end: 'center center',
				scrub: 1
			}
		})
	})
}

export default () => {}